import ArrayHelper from "~/ts/library/ArrayHelper";
import {__} from "~/ts/library/Translate";
import Random from "~/ts/library/Random";
import {MessageNavigatorPayloadInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryExposeInterface";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {TranslateMessagesMethod} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";
import OperatorApplicationMessageOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageOpenApiModel;

export default class CoreUiChatHistoryHelper {
    public static isOneOfCrossOperatorsChat(client?: OperatorApplicationApi.OperatorApplicationClientOpenApiModel): boolean {
        let type = client?.type;
        return type && (type.isCrossOperatorsChat || type.isCrossOperatorsConversationChat);
    }

    public static isOneOfCrossOperatorsChatMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel): boolean {
        return message.isCrossOperatorsChat || message.isCrossOperatorsConversationChat;
    }

    public static getMessageClass(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
        return `chat-history-message-${message.id}`;
    }

    public static getMessageSelector(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
        return `.${this.getMessageClass(message)}`
    }

    public static getUrlListForDownload(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel, snippetUrls?: string[]): string[] {
        let urlList: string[] = [];
        if (snippetUrls) {
            urlList.push(...snippetUrls);
        }
        let attachments = message.content.attachments;
        if (attachments) {
            urlList.push(...attachments.map(item => item.url));
        }
        /*
        if (message.content.text) {
            let array1;
            while ((array1 = fileshareRegexp.exec(message.content.text)) !== null) {
                urlList.push(array1[0]);
            }
        }*/
        urlList = ArrayHelper.unique(urlList);

        return urlList;
    }

    public static taggedMessagesToMessageNavigatorPayload(tag: OperatorApplicationApi.TaggedMessagesOpenApiModel): MessageNavigatorPayloadInterface {
        return {
            title: __(`Тэг`) + `: ${tag.tag}`,
            messageIds: tag.messageIds,
            key: Random.uid()
        };
    }

    public static translateMessages(method: TranslateMessagesMethod, messages: OperatorApplicationMessageOpenApiModel[]) {
        try {
            let promises = method(messages);
            for (let messageId in promises) {
                if (promises.hasOwnProperty(messageId)) {
                    let message = messages.find(message => message.id === parseInt(messageId));
                    if (message) {
                        message.isTranslatingNow = true;
                        (async function (message: OperatorApplicationMessageOpenApiModel) {
                            let promise = promises[messageId];
                            if (promise && message) {
                                try {
                                    let patchItems = await promise;
                                    let patch = {};
                                    for (let patchItem of patchItems) {
                                        ObjectHelper.setObjectValueByPath(
                                            patch,
                                            JSON.parse(patchItem.path),
                                            patchItem.value
                                        );
                                    }
                                    message.translatePatch = patch;
                                } catch (e) {

                                }
                                message.isTranslatingNow = false;
                            }
                        })(message);
                    }
                }
            }
        } catch (e) {

        }
    }
}

export type MessageStatusId = "delivered" | "readed";